module.exports = __webpack_public_path__ + "static/media/rada.75639778.png";